import { render, staticRenderFns } from "./RealTimeChatSettingMenu.vue?vue&type=template&id=6a6d97c0"
import script from "./RealTimeChatSettingMenu.vue?vue&type=script&lang=js"
export * from "./RealTimeChatSettingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports